const isDownloadLink = (anchor) => {
    const trackedFileTypes = [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".pptm" ]
    let downloadLinkQuery = trackedFileTypes.map(type => `a[href*="${type}"]`).join(', ')
    downloadLinkQuery += ', a[download]';
    return anchor.matches(downloadLinkQuery)
}

export { isDownloadLink }